export enum Races {
  'AfricanAmerican' = 'African American',
  'AlaskaNative' = 'Alaska Native',
  'AmericanIndian' = 'American Indian',
  'Asian' = 'Asian',
  'Caucasian' = 'Caucasian',
  'PacificIslander' = 'Pacific Islander',
  'Decline' = 'Decline to Answer',
}
